<template>
  <div class="main-body-container" style="display: flex;">
    <el-tabs
      v-model="activeTabKey"
      class="absolute"
      style="width: 100%;"
      @tab-click="handleTabClick"
    >
      <el-tab-pane label="品牌" name="one" lazy
        ><Item ref="one" type="1" title="品牌"
      /></el-tab-pane>
      <el-tab-pane label="分类" name="two" lazy
        ><Item ref="two" type="2" title="分类"
      /></el-tab-pane>
      <el-tab-pane label="产地" name="three" lazy
        ><Item ref="three" type="3" title="产地"
      /></el-tab-pane>
      <el-tab-pane label="容量" name="four" lazy
        ><Item ref="four" type="4" title="容量"
      /></el-tab-pane>
      <el-tab-pane label="类型" name="five" lazy
        ><Item ref="five" type="5" title="类型"
      /></el-tab-pane>
      <el-tab-pane label="口感" name="six" lazy
        ><Item ref="six" type="6" title="口感"
      /></el-tab-pane>
      <el-tab-pane label="瓶塞" name="seven" lazy
        ><Item ref="seven" type="7" title="瓶塞"
      /></el-tab-pane>
      <el-tab-pane label="萄萄品种" name="eight" lazy
        ><Item ref="eight" type="8" title="萄萄品种"
      /></el-tab-pane>
      <el-tab-pane label="香型" name="nine" lazy
        ><Item ref="nine" type="9" title="香型"
      /></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Item from './item'
export default {
  components: {
    Item
  },
  data() {
    return {
      activeTabKey: 'one'
    }
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'one') {
        this.$refs.one && this.$refs.one.formSearch()
      } else if (tab.name === 'two') {
        this.$refs.two && this.$refs.two.formSearch()
      } else if (tab.name === 'three') {
        this.$refs.three && this.$refs.three.formSearch()
      } else if (tab.name === 'four') {
        this.$refs.four && this.$refs.four.formSearch()
      } else if (tab.name === 'five') {
        this.$refs.five && this.$refs.five.formSearch()
      } else if (tab.name === 'six') {
        this.$refs.six && this.$refs.six.formSearch()
      } else if (tab.name === 'seven') {
        this.$refs.seven && this.$refs.seven.formSearch()
      } else if (tab.name === 'eight') {
        this.$refs.eight && this.$refs.eight.formSearch()
      } else if (tab.name === 'nine') {
        this.$refs.nine && this.$refs.nine.formSearch()
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-tabs.absolute {
  position: relative;
  .el-tabs__header {
    position: absolute;
    top: -36px;
    left: 280px;
  }
}
</style>
